<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 2.goodsTitle-container-start -->
    <!-- <goods-title></goods-title> -->
    <tabbar :tabbarIndex="0"></tabbar>
    <!-- <img width="100%" src="../../images/head.png"> -->
    <img
      width="100%"
      :src="web_top_imgurl"
      @click="link(web_top_linkurl)"
      alt=""
    />
    <marquee behavior="scroll" class="tishi">{{ web_rolling_notice }}</marquee>
    <div class="main">
      <img :src="web_order_success_imgurl" height="50%">
      <div class="suc">
        <!-- <img src="../../images/suc.png" width="80%" style="margin-left:60px;"/> -->
        <h3>{{ web_order_success }}</h3>
        <div class="phone">您的订单将于次日发货，节假日顺延。</div>
        <div class="phone1">
          如有疑问欢迎来电咨询:<span v-for="(item, index) of web_tel" :key="index"
              >{{ item }} {{ index + 1 == web_tel.length ? "" : "、" }}</span
            >
        </div>
        <div class="button" @click="back()">返 回</div>
      </div>
      <div v-html="web_order_success_2" class="shuoming">
      </div>
    </div>

    <!-- 4.goodsFooter-container-start -->
    <!-- <goods-footer></goods-footer> -->
    <c-footer></c-footer>
    <!-- 4.goodsFooter-container-end -->

    <success-cover :isShow="isShow" :showContent="showContent"></success-cover>
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import tabbar from "../../components/tabbar/tabbar";
import footer from "../../components/footer/footer";
// import goodsTitle from "../../components/goodsTitle/goodsTitle";
// import goodsFooter from "../../components/goodsFooter/goodsFooter";
import successCover from "../../components/successCover/successCover";
// import {
//   TCInterGGListRequest,
//   submitExchangeRequest,
//   TCDetailRequest,
// } from "../../public/js/service";
// var interval;
import { getLargeClientsInfoRequest } from "../../public/js/service";
export default {
  data() {
    // 1.data
    return {
      web_rolling_notice: "", //滚动公告
      web_top_imgurl: "", // pc顶部图片链接
      web_top_linkurl: "", // pc顶部跳转链接
      web_order_success: "",
      web_order_success_2: "",
      web_tel: "", // 1.7.客服电话
      web_order_success_imgurl:""
    };
  },

  components: {
    // 2.components
    // goodsTitle,
    // goodsFooter,
    tabbar,
    cFooter: footer,
    successCover,
  },

  methods: {
    back() {
      this.$router.replace("/home");
    },
    getCurrentPageInfoByLargeClientId() {
      // 3.5.通过大客户id获取页面数据
      let data = {
        sysId: this.sysId,
        bigClientId: this.bigClientId,
      };

      getLargeClientsInfoRequest(data).then((res) => {
        if (res) {
          let r = res.data[0];
          if (r.pc_img2) {
            this.leftImg = r.pc_img2;
          }
          if (r.show_tip == 0) {
            this.$notify({
              title: "提示",
              message: r.tip_info,
            });
          }
        }
      });
    },
    link(url) {
      if (url != "") {
        url =
          url.toLowerCase().indexOf("http:") > -1 ||
          url.toLowerCase().indexOf("https:") > -1
            ? url
            : "http://" + url;
        window.location = url;
      }
    },
  },
  mounted() {
    // 4.mounted
    this.web_rolling_notice = localStorage.web_rolling_notice || ""; //滚动公告
    this.web_top_imgurl = localStorage.web_top_imgurl || "";
    this.web_top_linkurl = localStorage.web_top_linkurl || "";
    this.web_order_success = localStorage.web_order_success || "";
    this.web_order_success_2 = localStorage.web_order_success_2 || "";
    this.web_tel = JSON.parse(localStorage.web_tel) || "";
    this.web_order_success_imgurl = localStorage.web_order_success_imgurl || "";
  },
};
</script>

<style scoped lang="scss">
.main {
  width: 900px;
  height: 800px;
  // border:1px solid #000;
  text-align: center;
  margin: auto;
  position: relative;
}
.main img{
  margin-top: 50px;
}
.suc{
  width: 100%;
  height: 120px;
  // border: 1px solid #d00000;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  position: absolute;
  top: 240px;
}
h3 {
width: 45%;
text-align: center;
  color: #d00000;
}
.phone {
  width: 100%;
  color: #d00000;
}
.phone1 {
  width: 100%;
  color: #d00000;
}
.button {
  width: 100px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  text-align: center;
  background-color: #eb3341;
  margin-left: -10px;
  margin-top: 90px;
  border-radius: 5px;
}
.shuoming{
   margin-top: 5%;
}
.tishi{
        display: flex;
        justify-content: center;
        // border: 1px solid #333;
        margin: auto;
        width: 1045px;
    }
</style>